import React from 'react';
import clsx from 'classnames';
import './index.css';

const Field = () => {
  const topList = [
    { title: '市政行业', img: '/images/field1.png' },
    { title: '通信行业', img: '/images/field2.png' },
    { title: '交通行业', img: '/images/field3.png' },
  ];

  const bottomList = [
    { title: '建筑行业', img: '/images/field4.png' },
    { title: '石化行业', img: '/images/field5.png' },
    { title: '电力行业', img: '/images/field6.png' },
    { title: '新能源行业', img: '/images/field7.png' },
  ];

  return (
    <div className={clsx('certificate-field')}>
      <div className={clsx('certificate-field-title')}>服务领域</div>
      <div className={clsx('certificate-field-list')}>
        <div className={clsx('certificate-field-top-list')}>
          {topList.map((item, index) => (
            <div className={clsx('certificate-field-top-item')} key={index}>
              <div className={clsx('certificate-field-top-item-mask')} />
              <img src={item.img} alt={item.title} width='100%' height='100%' />
              <div className={clsx('certificate-field-top-item-title')}>
                {item.title}
              </div>
            </div>
          ))}
        </div>
        <div className={clsx('certificate-field-bottom-list')}>
          {bottomList.map((item, index) => (
            <div className={clsx('certificate-field-bottom-item')} key={index}>
              <div className={clsx('certificate-field-top-item-mask')} />
              <img src={item.img} alt={item.title} width='100%' height='100%' />
              <div className={clsx('certificate-field-top-item-title')}>
                {item.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Field;
